// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2kkZI","imageUploader":"EGiftCard_imageUploader__E-qF9"};